import auth from '@/api/wechat/auth'
import userinfo from '@/api/wechat/userinfo'

import textmessage from '@/api/message/textmessage'

import commenttag from '@/api/baseinfo/commenttag'

import customer from '@/api/customer/customer'
import address from '@/api/customer/address'
import perferenceinfo from '@/api/customer/perferenceinfo'

import asset from '@/api/dashboard/asset'

import mycoupon from '@/api/asset/mycoupon'
import mycard from '@/api/asset/mycard'

import consumeorder from '@/api/order/consumeorder'
import comment from '@/api/order/comment'
import rechargeorder from '@/api/order/rechargeorder'

import skinreport from '@/api/skin/skinreport'

import healthreport from '@/api/health/healthreport'
import healthquestion from '@/api/health/healthquestion'

import card from '@/api/project/card'

export default {
    wechat: {
        auth: auth,
        userinfo:userinfo,
    },
    customer : {
        customer: customer,
        address : address,
        perferenceinfo:perferenceinfo,
    },
    baseinfo:{
        commenttag:commenttag,
    },
    message:{
        textmessage:textmessage,
    },
    dashboard:{
        asset : asset,
    },
    asset:{
        mycoupon : mycoupon,
        mycard : mycard,
    },
    order:{
        consumeorder : consumeorder,
        comment : comment,
        rechargeorder:rechargeorder,
    },
    skin:{
        skinreport : skinreport,
    },
    health:{
        healthreport : healthreport,
        healthquestion : healthquestion,
    },
    project:{
        card : card,
    }

}


// WEBPACK FOOTER //
// ./src/api/index.js